import { GetWorkspaceTasksQuotaResult } from '@indigohive/cogfy-types/endpoints/getWorkspaceTasksQuota'
import { RefreshCcw } from 'lucide-react'
import { FormattedNumber } from '../../../FormattedNumber'

export type DrawerTaskQuotaProps = {
  tasksQuota?: GetWorkspaceTasksQuotaResult
  loading?: boolean
  error?: Error | null
  onRefetch?: () => void
}

export function DrawerTaskQuota (props: DrawerTaskQuotaProps) {
  const { tasksQuota, loading, error, onRefetch } = props

  const available = tasksQuota?.availableTasks ?? 0
  const consumed = tasksQuota?.consumedTasks ?? 0

  const consumedPercentage =
    available === 0 && consumed === 0
      ? 0
      : available === 0 && consumed > 0
        ? 100
        : Math.floor((consumed / available) * 100)

  // If tasks quota loaded but there are no available tasks, we return null
  if (tasksQuota === null || (tasksQuota && tasksQuota.availableTasks === null)) {
    return null
  }

  return (
    <div className="w-full flex items-center justify-between gap-2 text-xs p-2 border-1 rounded-md hover:bg-base-200/50 transition-colors duration-200 ease-in-out">
      <span className='font-bold'>Tasks</span>
      {error
        ? (
          <>
            <span className="text-error">Error fetching data usage</span>
            <button
              className="btn btn-sm btn-ghost btn-circle"
              onClick={event => {
                event.preventDefault()
                onRefetch?.()
              }}
            >
              <RefreshCcw size={16} />
            </button>
          </>
          )
        : (
          <>
            <div className="h-1.5 my-2 grow bg-gray-200 rounded-sm overflow-hidden">
              {loading && <div className="skeleton w-full h-full" />}
              {!loading && (
                <div
                  className='h-full rounded transition-all duration-300 ease-linear bg-black'
                  style={{ width: `${consumedPercentage}%` }}
                />
              )}
            </div>

            {loading && <div className="skeleton h-4 w-20" />}
            {!loading && (
              <span className="opacity-40 text-end">
                <FormattedNumber value={consumed} compact /> / <FormattedNumber value={available} compact />
              </span>
            )}
          </>
          )}
    </div>
  )
}
